import React, { useState, useEffect } from "react";
require("../Navigation/Navigation.scss");

const preloadImage = (src) => {
  const img = new Image();
  img.src = src;
  return img;
};

const CardData = ({
  icon,
  description,
  buttonText,
  listItems,
  buttonLink,
  onHoverListItem,
  onLeaveListItem,
}) => (
  <div className="shop-card nav-card-2">
    <div className="card-icon">
    <a href={`${buttonLink}`}>
    <img src={icon} alt="Resource Image" />
    </a>
    </div>
    {description && (
      <div className="card-description">
        <p>{description}</p>
      </div>
    )}
    <div className="button-width">
      <a href={`${buttonLink}`}>
        <button className="card-button">{buttonText}</button>
      </a>
    </div>
    {listItems && (
      <ul className="card-list">
        {listItems.map((item, index) => (
          <li
            key={index}
            onMouseEnter={() => onHoverListItem(item)}
            onMouseLeave={onLeaveListItem}
          >
            <a href={`${item.navPath}`}>{item.navTitle}</a>
          </li>
        ))}
      </ul>
    )}
  </div>
);

const SubNavigation = ({
  subnavdata,
  calloutdata,
  heading,
  subheading,
  designcheckbox,
  displaylink,
  displaytext,
  displaytitle,
}) => {
  const [hoveredItem, setHoveredItem] = useState(null);

  useEffect(() => {
    subnavdata.forEach((card) => {
      window[card] = preloadImage(card.imagePath);
      card.subnavitemslist?.forEach((item) => (window[item] = preloadImage(item.navImagePath)));
    });
  }, [subnavdata]);

  const handleHoverListItem = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  return (
    <>
      {designcheckbox ? (
        <>
          {displaytitle && (
            <div className="resources-group">
              <span>{displaytitle}</span>
              {displaytext && (
                <a href={`${displaylink}`}>
                  <button>{displaytext}</button>
                </a>
              )}
            </div>
          )}
          {displaytitle && <hr />}
          <div className="shop-cards-container owners-hub-container">
            {subnavdata.map((card, index) => (
              <CardData
                key={index}
                icon={card.imagePath}
                buttonText={card.buttonText}
                buttonLink={card.buttonLink}
              />
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="shop-cards-container">
            <div className="hovered-image">
              {hoveredItem && (
                <>
                  <img
                    src={hoveredItem.navImagePath}
                    alt="Hovered Item"
                  />
                  <span>{hoveredItem.imageMsrp}</span>
                </>
              )}
            </div>
            {subnavdata.map((card, index) => (
              <CardData
                key={index}
                icon={card.imagePath}
                description={card.description}
                buttonText={card.buttonText}
                buttonLink={card.buttonLink}
                listItems={card.subnavitemslist}
                onHoverListItem={handleHoverListItem}
                onLeaveListItem={handleMouseLeave}
              />
            ))}
            {calloutdata !== "null" &&
              calloutdata &&
              heading &&
              subheading && (
                <div className="info-box">
                  <div className="title">{heading}</div>
                  <div className="description">{subheading}</div>
                  {calloutdata.map((btn) => (
                    <div className="button-container" key={btn.buttonTitle}>
                      <a
                        href={`${btn.buttonPath}`}
                        rel="noopener noreferrer"
                      >
                        <button>{btn.buttonTitle}</button>
                      </a>
                    </div>
                  ))}
                </div>
              )}
          </div>
        </>
      )}
    </>
  );
};

export default SubNavigation;
